import React, { Component } from "react"
import { Col, Button, Image, Container, Row } from "react-bootstrap"
import CollectionSite from "../../api/Location/LocationModel/CollectionSite"
import clinicIcons_FFEnabled from "../../assets/images/clinic-icons_formfox-enabled.png"
import clinicIcons_NotFFEnabled from "../../assets/images/clinic-icons_not-formfox-enabled.png"
import clinicIcons_Marketplace from "../../assets/images/clinic-icons_marketplace.png"
import priceTier_Silver from "../../assets/images/seal-icons_silver.png"
import priceTier_Gold from "../../assets/images/seal-icons_gold.png"
import priceTier_Platinum from "../../assets/images/seal-icons_platinum.png"
import priceTier_GoldPlus from "../../assets/images/seal-icons_goldplus.png"
import clinicRating_3Stars from "../../assets/images/price-icons_3-star.png"
import clinicRating_4Stars from "../../assets/images/price-icons_4-star.png"
import clinicRating_5Stars from "../../assets/images/price-icons_5-star.png"
import { FaChevronUp, FaChevronDown } from "react-icons/fa"
import FormatPhone from "../../formatters/FormatPhone"
import SiteService from "../../api/Location/LocationModel/SiteService"
import { SiteServices } from "./SiteServices"

interface ImagesMap { [key: string]: string }
const PRICE_TIER_IMAGES: ImagesMap = {
  'silver': priceTier_Silver,
  'gold': priceTier_Gold,
  'platinum': priceTier_Platinum,
  'gold plus': priceTier_GoldPlus,
}

export interface SiteCardProps {
  site: CollectionSite
  onSiteSelected?: (site: CollectionSite) => void
}

export default class SiteCard extends Component<SiteCardProps, { open: boolean }> {
  state = { open: false }
  
  getServiceItem(service: SiteService, isMP: boolean) {
    if (!service) {
      return <></>
    }

    if (!isMP) {
      return <>
        <div><span>{service.Name}</span></div>
      </>
    }

    let imageSrc = PRICE_TIER_IMAGES[service.PriceTier?.toLowerCase() || ''];
    if (imageSrc) {
      return <>
        <Image src={imageSrc} /><span>{service.Name}</span>
      </>
    } else {
      let displayName = service.PriceTierDisplayName || service.PriceTier;
      return <>
        {displayName !== "" && <span className="primary">{displayName}</span>}
        <div><span>{service.Name}</span></div>
      </>
    }
  }

  render() {
    const { site } = this.props
    return (
      <Container fluid className="site-card">
        <Row>
          <Col xs={1} className="p-0">
            {(site.FFEnabled && !site.IsMarketPlace) && <Image src={clinicIcons_FFEnabled} className="w-100 h-auto" />}
            {(!site.FFEnabled && !site.IsMarketPlace) && <Image src={clinicIcons_NotFFEnabled} className="w-100 h-auto" />}
            {(site.IsMarketPlace) && <Image src={clinicIcons_Marketplace} className="w-100 h-auto" />}
          </Col>
          <Col xs={11} className="pr-3">
            <Button variant="icon-link" className="float-right mr-n4" onClick={() => this.setState({ open: !this.state.open })}>
              {this.state.open ? <FaChevronUp /> : <FaChevronDown />}
            </Button>
            <div className="font-weight-bold">
              <span className="text-uppercase">{site.Name}</span>
              {site.IsMarketPlace && <span> (Marketplace Enabled)</span>}
            </div>
            {site.Distance && <div className="float-right pl-1">({site.Distance.toFixed(2)} Miles)</div>}
            <div className="float-left">{site.Address1}{site.Address2 && ` ${site.Address2}`} </div>
            <div className="float-left">{site.City && ` ${site.City}`}{site.State && ` ${site.State}`}{site.Zip && ` ${site.Zip}`}</div>
          </Col>
        </Row>
        <Row hidden={!this.state.open}>
          <Col xs={1}></Col>
          <Col xs={10}>
            {site.HoursOfOperation && <div>{site.HoursOfOperation}</div>}
            {site.Phone && <div className="d-inline-block pr-3">Phone: {FormatPhone(site.Phone)}</div>}
            {site.Fax && <div className="d-inline-block">Fax1: {FormatPhone(site.Fax)}</div>}
            {site.SiteRating > 0 && (
              <div className="rating">
                Rating
                {site.SiteRating <= 3 && <Image src={clinicRating_3Stars} />}
                {site.SiteRating === 4 && <Image src={clinicRating_4Stars} />}
                {site.SiteRating === 5 && <Image src={clinicRating_5Stars} />}
              </div>
            )}
            <div className="services">
              SERVICES
              {site.SiteServices && site.SiteServices.map(service => (
                <div key={service.Code}>
                  {this.getServiceItem(service, site.IsMarketPlace)}
                </div>
              ))}
            </div>
          </Col>
          <Col xs={1}></Col>
        </Row>
        <Row>
          <Col className="pl-0 pt-2 pb-3 pr-3">
            {this.props.onSiteSelected && <Button variant="primary" size="sm" className="w-100 rounded-pill" onClick={() => this.props.onSiteSelected && this.props.onSiteSelected(site)}>SELECT SITE</Button>}
          </Col>
        </Row>
      </Container >
    )
  }
}
